/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { ContentZoneContext } from "cms/components/context/index";
import { ComponentIcon } from "cms/components/components/component-icon";

const ComponentAvatar = () => {

    const { component } = useContext(ContentZoneContext);
    const { type } = component || {};

    return (
        <div className='simplicity-composer-header-icon-box'>
            <ComponentIcon component={type} className={"avatar"} />
        </div>
    );
};

export { ComponentAvatar };
